import { useState, useEffect } from "react";
import { instance } from "../../components/AxiosClient";

const comCode = process.env.REACT_APP_COM_CODE;

const getQueueuList = async (payload) => {
  try {
    const response = await instance.post(
      `/v1/container/manager/company/${comCode}/getAllOrder`,
      payload
    );

    if (response.status === 200) {
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {}
};

const getQueueuStatus = async () => {
  try {
    const response = await instance.get(
      `/v1/container/manager/company/${comCode}/getStatus`);

    if (response.status === 200) {
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {}
};

const getContractPaging = async (payload) => {
  try {
    const response = await instance.post(
      `/v1/container/manager/company/${comCode}/getContractPaging`,
      payload
    );
    if (response.status === 200) {
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {}
}

const getQueueListApi = async (payload) => {
  try {
    const response = await instance.post(
      `/v5/order/manager/company/${comCode}/web/deliveryorder/reportv2`,
      payload
    );
    if (response.status === 200) {
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {}
}

const getQueueOnworkApi = async (date) => {
  try {
    const response = await instance.get(
      `/v5/order/manager/company/${comCode}/web-tas/current-queue-onwork?deliveryDate=${date}`
    );
    if (response.status === 200) {
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {}
}

const UpdateStatusQueue = async (payload,id) => {
  try {
    const response = await instance.put(
      `/v5/order/manager/company/${comCode}/web/update-deliveryorder/${id}`,
      payload
    );
    if (response.status === 200) {
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {}
}

export { getQueueuList , getQueueuStatus, getContractPaging, getQueueListApi, getQueueOnworkApi,UpdateStatusQueue};
